import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
  code: "hy",
  messages: {
    inputMenu: {
      noMatch: "\u0540\u0561\u0574\u0568\u0576\u056F\u0576\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
      create: '\u054D\u057F\u0565\u0572\u056E\u0565\u056C "{label}"'
    },
    calendar: {
      prevYear: "\u0546\u0561\u056D\u0578\u0580\u0564 \u057F\u0561\u0580\u056B",
      nextYear: "\u0540\u0561\u057B\u0578\u0580\u0564 \u057F\u0561\u0580\u056B",
      prevMonth: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0561\u0574\u056B\u057D",
      nextMonth: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0561\u0574\u056B\u057D"
    },
    inputNumber: {
      increment: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C",
      decrement: "\u054A\u0561\u056F\u0561\u057D\u0565\u0581\u0576\u0565\u056C"
    },
    commandPalette: {
      placeholder: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u0570\u0580\u0561\u0574\u0561\u0576 \u056F\u0561\u0574 \u0578\u0580\u0578\u0576\u0565\u0584...",
      noMatch: "\u0540\u0561\u0574\u0568\u0576\u056F\u0576\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    selectMenu: {
      noMatch: "\u0540\u0561\u0574\u0568\u0576\u056F\u0576\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
      create: '\u054D\u057F\u0565\u0572\u056E\u0565\u056C "{label}"',
      search: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574..."
    },
    toast: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    carousel: {
      prev: "\u0540\u0565\u057F",
      next: "\u0531\u057C\u0561\u057B",
      goto: "\u0531\u0576\u0581\u0576\u0565\u056C {slide}-\u056B\u0576"
    },
    modal: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    slideover: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    alert: {
      close: "\u0553\u0561\u056F\u0565\u056C"
    },
    table: {
      noData: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576"
    }
  }
});
